export const UPDATE_FRACTURE_STATE = "UPDATE_FRACTURE_STATE"